// extracted by mini-css-extract-plugin
export default {"container":"uca-z","creativeContainer":"vca-z","copy":"wca-z","cta":"xca-z","disabled":"yca-z","flipped":"zca-z","productCard":"Aca-z"};